import dayjs from 'dayjs';
import { CreneauType } from '../../app.constants';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { INommable } from '../nommable.interface';
import { VacationTournee } from '../vacation/vacation-tournee.model';
import { Consigne } from './consigne.model';
import { CreneauIntervention } from './creneau-intervention.model';
import { CreneauRonde } from './creneau-ronde.model';
import { ICreneau } from './creneau.interface';
import { Zone } from './zone.model';

export class CreneauTournee implements ICreneau {
  constructor(
    public readonly id: string,
    public readonly debut?: dayjs.Dayjs,
    public readonly fin?: dayjs.Dayjs,
    public readonly vacation?: VacationTournee,
    public readonly consignes: Consigne[] = [],
    public readonly geolocEnabled = false,
    public rondes: CreneauRonde[] = [],
    public readonly inters: CreneauIntervention[] = [],
    public readonly materiel: string[] = [],
    public readonly champsPersonnalises: ChampCompteRendu[] = [],
    public readonly zones: Zone[] = [],
    public readonly type = CreneauType.TOURNEE,
    public readonly zone?: INommable
  ) {}

  public static hydrate(creneau: CreneauTournee): CreneauTournee {
    return new CreneauTournee(
      creneau.id,
      creneau.debut ? dayjs(creneau.debut) : undefined,
      creneau.fin ? dayjs(creneau.fin) : undefined,
      creneau.vacation ? VacationTournee.hydrate(creneau.vacation) : undefined,
      creneau.consignes?.map(Consigne.hydrate) ?? [],
      creneau.geolocEnabled,
      creneau.rondes?.map(subCreneau => CreneauRonde.hydrate(subCreneau as CreneauRonde)) ?? [],
      creneau.inters?.map(CreneauIntervention.hydrate) ?? [],
      Object.assign([], creneau.materiel),
      creneau.champsPersonnalises?.map(ChampCompteRendu.hydrate) ?? [],
      creneau.zones?.map(Zone.hydrate) ?? [],
      creneau.type,
      creneau.zone
    );
  }
}
